<template>
  <div
    v-if="permissionNotesManagementPackageComputed"
    class="upload-container card card-small p-3"
    role="dialog"
    aria-modal="true"
    :aria-label="$t('general.documents.upload')"
  >
    <div class="upload-container__body">
      <div class="d-flex flex-column">
        <label>{{ $t('general.documents.file') }}</label>
        <input ref="fileInput" @change="fileSelected($event)" type="file"/>
      </div>
      <div class="mt-2 d-flex flex-column">
        <label>{{ $t('general.documents.title') }}</label>
        <d-input v-model="fileTitle"></d-input>
      </div>
    </div>
    <div class="upload-container__actions d-flex flex-row-reverse align-items-center mt-4">
      <d-button @click="uploadSubmit">{{ $t('generalMessages.save') }}</d-button>
      <span class="link link-secondary mr-3" @click="close">{{ $t('general.documents.close') }}</span>
    </div>
  </div>
</template>

<script>
import documentsService from '@/services/documents.service';

export default {
  name: 'UploadPopup',
  props: {
    recordId: {
      required: true,
      type: Number,
    },
    recordType: {
      required: true,
      type: Object,
      default() {
        return {
          entity: '',
          fieldName: '',
        };
      },
    },
  },
  data() {
    return {
      selectedFile: undefined,
      fileTitle: '',
    };
  },
  methods: {
    async uploadSubmit() {
      // this.$store.commit('changeShowLoader', true);

      const requestData = new FormData();
      requestData.append('doc', this.selectedFile);

      const headers = { 'Content-Type': 'multipart/form-data' };

      await documentsService.upload(
        requestData,
        {
          id: this.recordId,
          recordType: this.recordType.entity,
          documentTitle: this.fileTitle,
        },
        headers,
      )
        .then((data) => {
          if (data) {
            this.$toast.success(this.$t('general.documents.fileUploadedSuccessfully'));
            this.close(true);
          } else {
            throw 'Server return false or error';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.document'), 'save');
        });

      // this.$store.commit('changeShowLoader', false);
    },
    close(reload = false) {
      this.$emit('close-upload', reload);
    },

    fileSelected(e) {
      if (e.target.files.length > 0) {
        this.selectedFile = e.target.files[0];
      }
    },
  },
  computed: {
    permissionNotesManagementPackageComputed() {
      return this.hasFeature('follow-ups');
    },
  },
};
</script>

<style scoped>
.upload-container{
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 2rem);
  max-width: min(30rem, 100%);
  min-width: min(18rem, 100%);
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 1;
}
.upload-container__body {
  min-height: 0;
  overflow-y: auto;
}
.upload-container__actions {
  flex: 0 0 auto;
}
@media (max-width: 575px) {
  .upload-container {
    max-height: calc(100vh - 1.25rem);
    min-width: 0;
  }
}
</style>
